import { StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { Ionicons } from '@expo/vector-icons'

// styles
import { globalStyles, colorPalette } from '../../static/styles/global'

// components
import HomeMessages from '../home/HomeMessages'
import SendReplyMessages from './SendReplyMessages'

// helpers
import { isMessageType } from '../../helpers/communicateHelper'

// types
import { MessageType } from '../../types/communicateTypes'

interface MessageItemProps {
  title: string
  from: string
  sentMessageLabel: string
  sentMessageDate?: string
  replyMessageLabel?: string
  replyMessageDate?: string
  messageType: MessageType
  initiatorType: 'E' | 'A'
  message?: string
  response?: string
  action: any
  arrow?: boolean
  unread?: boolean
  disabled?: boolean
}

const MessageItem = ({
  title,
  from,
  sentMessageLabel,
  sentMessageDate,
  replyMessageLabel,
  replyMessageDate,
  messageType,
  initiatorType,
  message,
  response,
  action,
  arrow = true,
  unread = true,
  disabled
}: MessageItemProps): JSX.Element => {
  return (
    <TouchableOpacity
      onPress={action}
      style={{ paddingHorizontal: 2 }}
      disabled={
        disabled !== undefined
          ? disabled
          : !(initiatorType === 'A' && isMessageType(messageType) && !response)
      }
    >
      <View
        style={[
          globalStyles.hDirection,
          globalStyles.hBetweenItems,
          globalStyles.vCenterItems,
          globalStyles.flexWrapped,
          globalStyles.mb1
        ]}
      >
        <View style={[globalStyles.hDirection, globalStyles.vCenterItems]}>
          {unread && <View style={[styles.bullet, globalStyles.mr2]} />}
          <Text
            style={[
              globalStyles.text,
              globalStyles.fs12,
              globalStyles.fwBold,
              globalStyles.blackTextColor
            ]}
          >
            {title}
          </Text>
        </View>
        {initiatorType === 'A' && !response && (
          <View style={[globalStyles.relativePosition, globalStyles.rn6]}>
            <Ionicons
              name="chevron-forward"
              size={24}
              color={colorPalette.secondary}
            />
          </View>
        )}
      </View>
      <SendReplyMessages
        message={message}
        reply={response}
        sentMessageLabel={sentMessageLabel}
        sentMessageDate={sentMessageDate}
        replyMessageLabel={replyMessageLabel}
        replyMessageDate={replyMessageDate}
        initiatorType={initiatorType}
      />
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  bullet: {
    width: 10,
    height: 10,
    backgroundColor: colorPalette.secondary,
    borderRadius: 50
  }
})

export default MessageItem
